<template>
  <div>
    <el-table :data="records" stripe style="width: 100%">
      <el-table-column
        align="left"
        :label="`导${category == 1 ? '出' : '入'}人`"
        prop="user_name"
      >
      </el-table-column>
      <el-table-column
        align="left"
        :label="`导${category == 1 ? '出' : '入'}时间`"
      >
        <div slot-scope="scope" style="word-break: break-word">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
        </div>
      </el-table-column>
      <el-table-column align="center" label="操作" v-if="!isMobile()">
        <template slot-scope="scope">
          <span class="pointer text-primary" @click="download(scope.row.file)"
            >下载文件</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      layout="total, prev, pager, next"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { customerExportRecordList } from '@/service/getData'
import { isMobile } from '@/util/index'
import { host } from '@/config/env'
import download from 'downloadjs'

export default {
  props: {
    category: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      host,
      isMobile,
      records: [],
      filter: {
        page: 1,
        size: 20,
      },
      total: 0,
    }
  },
  watch: {
    'filter.page': function () {
      this.getRecords()
    },
  },
  created() {
    this.getRecords()
  },
  methods: {
    async getRecords() {
      let res = await customerExportRecordList({
        page: this.filter.page - 1,
        size: this.filter.size,
        category: this.category,
      })
      if (res.code == 0) {
        this.records = res.data.list
        this.total = res.data.total
      }
    },
    download(file) {
      const file_name = file.split('/').pop()
      var x = new XMLHttpRequest()
      x.open('GET', this.host + file, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        download(e.target.response, file_name)
      }
      x.send()
    },
  },
}
</script>